exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr {\n  width: 100%;\n  margin-top: 0px;\n  margin-bottom: 30px; }\n\n.team-group-header {\n  font-weight: normal; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/dod/companyintroduction/src/app/team/team.component.scss
// module id = ../../../../../src/app/team/team.component.scss
// module chunks = main